// Whether a form asks for a number the server otherwise reads from the token's sheet (issue 1547): the decker's
// Detection Factor, the driver's control rig, the caster's or conjurer's Magic and drain rating. A token with no sheet
// types it; one whose sheet could not be read just now may; one whose sheet lacks it (the answer's `unread`) must.
// Kept apart from `entries` so the forms' tests, which stand in for the requests, keep the rule.
import type { TestsAnswer } from '../../entries';

export const asksFor = (character: string | null | undefined, answer: TestsAnswer | 'loading', ...keys: string[]): boolean =>
  !character || (answer !== 'loading' && (answer === null || keys.some((k) => answer.unread?.includes(k))));
